import { render } from "./UnsubscribedPluginDialog.vue?vue&type=template&id=2cea9c8c"
import script from "./UnsubscribedPluginDialog.vue?vue&type=script&lang=js"
export * from "./UnsubscribedPluginDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItemLabel,QBtn});
